import { useAppSelector } from 'hooks';
import { AccessRoles } from 'constants/enums';
import { getUserRoles } from 'store/oauth/reducer';

// The one migration predicate: every migration surface asks here rather than testing roles.
const useCanMigratePatients = () =>
  // The boolean is derived inside the selector on purpose: getUserRoles maps a new array every
  // call, so selecting it subscribes the caller to every dispatch.
  useAppSelector((state) => {
    const userRoles = getUserRoles(state) || [];
    return userRoles.includes(AccessRoles.SUPPORT) || userRoles.includes(AccessRoles.SYSOP);
  });

export default useCanMigratePatients;
